import { Component } from '@angular/core';

interface Benefit {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-benefits-grid-redesign',
  templateUrl: './benefits-grid-redesign.component.html',
  styleUrls: ['./benefits-grid-redesign.component.scss']
})
export class BenefitsGridRedesignComponent {

  benefits: Benefit[] = [
    {
      icon: 'benefit1.svg',
      title: 'AI-DRIVEN EARLY DETECTION',
      description: 'AI continuously analyzes multiple data signals to identify subtle risk patterns humans can’t reliably detect.'
    },
    {
      icon: 'benefit2.svg',
      title: 'INCREASED PATIENT SAFETY',
      description: 'Earlier awareness allows teams to intervene sooner and prevent critical incidents.'
    },
    {
      icon: 'benefit3.svg',
      title: 'FASTER RESPONSE TIMES',
      description: 'Real-time alerts ensure the right people are notified when every minute matters.'
    },
    {
      icon: 'benefit3.svg',
      title: 'LOWER PREVENTABLE COSTS',
      description: 'Early intervention helps reduce escalation, emergency events, and avoidable hospitalizations.'
    }
  ];

  trackByTitle(index: number, benefit: Benefit): string {
    return benefit.title;
  }

}